import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';
import { AnnouncementAnchor } from '@/contexts/announcements/AnnouncementAnchor.comp.tsx';
import { AnnouncementAnchorKey } from '@/contexts/announcements/announcements.definitions.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { ProcessMultiOfferGroupAccordion } from '@/views/processesDetails/components/multiOffers/comp/ProcessMultiOfferGroupAccordion.comp.tsx';
import { useGetProcessMultiOffers } from '@/views/processesDetails/components/multiOffers/util/useGetProcessMultiOffers.util.ts';

type Props = {
  processId: string;
};

export const ProcessDetailsMultiOffers: React.FC<Props> = ({ processId }) => {
  const { t } = useTranslationWithPrefix('views.process.multiOffer');
  const { isPending, multiOffers } = useGetProcessMultiOffers({ processId });

  if (isPending) {
    return (
      <Stack sx={{ alignItems: 'center', py: 4 }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (multiOffers.length === 0) {
    return (
      <AnnouncementAnchor anchorKey={AnnouncementAnchorKey.PROCESS_MULTI_OFFERS_TAB}>
        <Typography sx={{ color: themeColors.greyDark, py: 2 }} variant="f14Regular">
          {t('details.noGroups')}
        </Typography>
      </AnnouncementAnchor>
    );
  }

  return (
    <AnnouncementAnchor anchorKey={AnnouncementAnchorKey.PROCESS_MULTI_OFFERS_TAB}>
      <Stack spacing={1.5}>
        {multiOffers.map(group => (
          <ProcessMultiOfferGroupAccordion defaultExpanded group={group} key={group.groupId} />
        ))}
      </Stack>
    </AnnouncementAnchor>
  );
};
